function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "PlusNavigationClick",
  transform: "translate(-362 -24)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_982",
  "data-name": "Group 982",
  transform: "translate(2763 -9469.526)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_117",
  className: "background",
  "data-name": "Ellipse 117",
  cx: 22,
  cy: 22,
  r: 22,
  transform: "translate(-2401 9493.526)",
  fill: "#f2f7fa"
})), /*#__PURE__*/React.createElement("g", {
  id: "P\\u0159idatZad\\xE1n\\xEDButton_M",
  className: "plus",
  transform: "translate(365.01 27.387)",
  fill: "none",
  stroke: "#002d56",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  id: "Line_97",
  "data-name": "Line 97",
  transform: "rotate(-90 12.82 5.83)",
  d: "M0 0v24"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_98",
  "data-name": "Line 98",
  transform: "translate(18.991 6.613)",
  d: "M0 0v24"
})));

function SvgPlusAddRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusAddRound);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NCIgaGVpZ2h0PSI0NCIgdmlld0JveD0iMCAwIDQ0IDQ0Ij4KICA8ZyBpZD0iUGx1c05hdmlnYXRpb25DbGljayIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM2MiAtMjQpIj4KICAgIDxnIGlkPSJHcm91cF85ODIiIGRhdGEtbmFtZT0iR3JvdXAgOTgyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNzYzIC05NDY5LjUyNikiPgogICAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzExNyIgY2xhc3M9ImJhY2tncm91bmQiIGRhdGEtbmFtZT0iRWxsaXBzZSAxMTciIGN4PSIyMiIgY3k9IjIyIiByPSIyMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI0MDEgOTQ5My41MjYpIiBmaWxsPSIjZjJmN2ZhIi8+CiAgICA8L2c+CiAgICA8ZyBpZD0iUMWZaWRhdFphZMOhbsOtQnV0dG9uX00iIGNsYXNzPSJwbHVzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNjUuMDEgMjcuMzg3KSI+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzk3IiBkYXRhLW5hbWU9IkxpbmUgOTciIHkyPSIyNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNi45OSAxOC42NDkpIHJvdGF0ZSgtOTApIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDJkNTYiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgICA8bGluZSBpZD0iTGluZV85OCIgZGF0YS1uYW1lPSJMaW5lIDk4IiB5Mj0iMjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4Ljk5MSA2LjYxMykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMmQ1NiIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };